export default __webpack_public_path__ + "static/media/booth2.a947ad4c.png";